<!--
 * @Description  : 安招采服务管理 -- CA办理记录下方内容
 * @Author       : 王帅
 * @Date         : 2026-07-14 16:59:56
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-07-14 17:20:11
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\platform-services\azc-components\tab-records.vue
-->
<template>
	<div class="tab-content">
		<div class="content-header">
			<div class="btn-box">
				<el-button type="primary" class="btn-blue" size="small" @click="doExport">
					导出
				</el-button>
			</div>
		</div>
		<!-- 非请求参数 正常查看 -->
		<div class="w-table-layout w-table-page">
			<div class="w-table-content bd-table">
				<el-table :data="filterData" height="100%" highlight-current-row row-key="id" border ref="table" v-if="!loading">
					<el-table-column type="index" label="序号" width="60" header-align="center" align="center">
						<template slot-scope="scope">
							<span class="">{{ parseInt(scope.$index) + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="mainType" label="主体类型" show-overflow-tooltip="" width="100" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.mainType == 0">个人</span>
							<span v-else-if="scope.row.mainType == 1">企业</span>
						</template>
					</el-table-column>
					<el-table-column prop="lockType" label="锁类型" width="120" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.lockType == 0">副锁</span>
							<span v-else-if="scope.row.lockType == 1">主锁</span>
						</template>
					</el-table-column>
					<el-table-column prop="owner" label="企业名称" width="240" show-overflow-tooltip header-align="center"></el-table-column>
					<el-table-column prop="idNo" label="税号" width="180" show-overflow-tooltip header-align="center"></el-table-column>
					<el-table-column prop="transactType" label="办理类型" width="120" align="center">
						<template slot-scope="scope">
							<span>{{ transactTypeName(scope.row.transactType) }}</span>
						</template>
					</el-table-column>

					<el-table-column
						prop="cerSerial"
						label="签名证书序列号"
						width="200"
						show-overflow-tooltip
						header-align="center"
					></el-table-column>
					<el-table-column prop="issueDate" label="证书签发时间" min-width="150" show-overflow-tooltip align="center"></el-table-column>
					<el-table-column prop="validDate" label="证书有效截止时间" min-width="200" align="center"></el-table-column>
					<el-table-column prop="cerState" label="证书状态" width="110" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.cerState == 0">已废除</span>
							<span v-else-if="scope.row.cerState == 1">已发证</span>
							<span v-else-if="scope.row.cerState == 2">已归档</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" min-width="160">
						<template slot-scope="scope">
							<el-button
								type="primary"
								size="small"
								round
								plain
								class="table-btn"
								v-if="roleBtns.includes('detail')"
								@click="getDetail(scope.row)"
							>
								<svg-icon icon-class="form-details"></svg-icon> 查看
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="w-table-footer">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="pageList"
					:page-size="pageSize"
					:total="total"
					layout="total, sizes, prev, pager, next, jumper"
				>
				</el-pagination>
			</div>
		</div>

		<!--详情-->
		<el-dialog
			:visible.sync="dialogObj.visible"
			:title="dialogObj.title"
			:width="dialogObj.width"
			class="primary-dialog"
			:close-on-click-modal="false"
			@closed="handleClosed"
			top="3vh"
		>
			<Panel :expand="true" title="办理信息">
				<el-form class="tableForm" size="medium" ref="formObjRfe" label-width="160px" :model="formObj" :show-message="false">
					<el-form-item label="主体类型">
						<span class="ml10">{{ formObj.mainType == '0' ? '个人' : formObj.mainType == '1' ? '企业' : '-' }}</span>
					</el-form-item>
					<el-form-item label="锁类型">
						<span class="ml10">{{ formObj.lockType == '0' ? '副锁' : formObj.lockType == '1' ? '主锁' : '-' }}</span>
					</el-form-item>
					<el-form-item label="企业名称" prop="sname">
						<span class="ml10">{{ formObj.owner || '-' }}</span>
					</el-form-item>
					<el-form-item label="税号" prop="sname">
						<span class="ml10">{{ formObj.idNo || '-' }}</span>
					</el-form-item>
					<el-form-item label="办理类型" prop="sname">
						<span class="ml10">{{ transactTypeName(formObj.transactType) || '-' }}</span>
					</el-form-item>
					<el-form-item label="证书签发时间" prop="sname">
						<span class="ml10">{{ formObj.issueDate || '-' }}</span>
					</el-form-item>
					<el-form-item label="证书有效期起止时间" prop="sname">
						<span class="ml10">{{ formObj.validDate || '-' }}</span>
					</el-form-item>
					<el-form-item label="签名证书序列号" prop="sname">
						<span class="ml10">{{ formObj.cerSerial || '-' }}</span>
					</el-form-item>
					<el-form-item label="介质(KEY)序列号" prop="sname">
						<span class="ml10">{{ formObj.medSerial || '-' }}</span>
					</el-form-item>
					<el-form-item label="证书状态" prop="sname">
						<span class="ml10">{{
							formObj.lockType == '0' ? '已废除' : formObj.lockType == '1' ? '已发证' : formObj.lockType == '2' ? '已归档' : '-'
						}}</span>
					</el-form-item>
					<el-form-item label="经办人" prop="sname">
						<span class="ml10">{{ formObj.handler || '-' }}</span>
					</el-form-item>
					<el-form-item label="经办人证件号" prop="sname">
						<span class="ml10">{{ formObj.handlerNo || '-' }}</span>
					</el-form-item>
					<el-form-item label="办理费用" prop="sname">
						<el-input v-model="formObj.transactFee" disabled>
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
					<el-form-item label="支付方式" prop="sname">
						<span class="ml10">{{ formObj.payType || '-' }}</span>
					</el-form-item>
				</el-form>
			</Panel>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { exportPlus } from 'utils/tools'
import * as Api from '@/api/modules/platform-service/index'

export default {
	name: '',
	props: {
		searchForm: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			filterData: [],
			loading: false,
			tableShow: true,
			pageList: [10, 20, 30, 50, 100], // 显示条数数组
			currentPage: 1, // 当前页码
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			dialogObj: {
				visible: false,
				width: '1000px',
				title: '办理记录详情' //标题
			},
			formObj: {}
		}
	},
	methods: {
		//获得列表数据
		getData(isBack) {
			this.filterData = []

			let params = Object.assign({}, this.searchForm)
			// if (params.dateArr && params.dateArr.length > 0) {
			// 	params.payStartTime = params.dateArr[0] + ' 00:00:00'
			// 	params.payEndTime = params.dateArr[1] + ' 23:59:59'
			// } else {
			// 	params.payStartTime = ''
			// 	params.payEndTime = ''
			// }
			// delete params.dateArr

			this.loading = true

			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize

			Api.getPageCas(params)
				.then((res) => {
					let resData = res.data.pageList ? res.data.pageList : res.data
					this.filterData = resData.records
					this.currentPage = parseInt(resData.current)
					this.total = parseInt(resData.total)
					this.pageSize = parseInt(resData.size)
				})
				.catch((err) => {})
				.finally(() => {
					this.loading = false
					setTimeout(() => {
						this.$refs.table ? this.$refs.table.doLayout() : ''
					}, 500)
				})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},

		// 重置
		doReset() {
			this.pageSize = 10
			this.currentPage = 1
			this.getData()
		},

		//办理类型处理
		transactTypeName(type) {
			let text = ''
			switch (type) {
				case 0:
					text = '副锁新办'
					break
				case 1:
					text = '副锁延期'
					break
				case 2:
					text = '企业主锁补办'
					break
				case 3:
					text = '企业主锁补办+企业主锁延期'
					break
				case 4:
					text = '企业主锁补办+企业主锁延期+签章重做'
					break
				case 5:
					text = '企业主锁新办'
					break
				case 6:
					text = '业主锁新办+企业主锁延期'
					break
				case 7:
					text = '企业主锁延期'
					break
				case 8:
					text = '签章重做'
					break
				case 9:
					text = '证书废除'
					break
				case 10:
					text = '证书信息变更'
					break
				case 11:
					text = '其他'
					break
			}
			return text
		},
		//查看详情
		getDetail(row) {
			this.formObj = row || {}
			this.dialogObj.visible = true
		},
		//关闭弹窗
		handleClosed() {
			this.formObj = {}
			this.dialogObj.visible = false
		},
		//导出
		doExport() {
			const params = {
				owner: this.searchForm.owner,
				idNo: this.searchForm.idNo,
				cerState: this.searchForm.cerState,
				lockType: this.searchForm.lockType
			}
			exportPlus('/ahCa/expertCas', params)
		}
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),

		...mapState('user', { userInfo: (state) => state.userInfo }),

		// 日期选择快捷选项
		pickerOptions() {
			let that = this
			// 本日
			let dayStart = this.$utils.getWhatDay(new Date(), 0, 'first')
			let dayEnd = this.$utils.getWhatDay(new Date(), 0, 'last')
			// 本月
			let monthStart = this.$utils.getWhatMonth(new Date(), 0, 'first')
			let monthEnd = this.$utils.getWhatMonth(new Date(), 0, 'last')
			// 本年
			let yearStart = this.$utils.getWhatYear(new Date(), 0, 'first')
			let yearEnd = this.$utils.getWhatYear(new Date(), 0, 'last')
			return {
				shortcuts: [
					{
						text: '今日',
						onClick(picker) {
							console.log('😍 ~ picker:', picker)
							picker.$emit('pick', [dayStart, dayEnd])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '本月',
						onClick(picker) {
							picker.$emit('pick', [monthStart, monthEnd])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '本年',
						onClick(picker) {
							picker.$emit('pick', [yearStart, yearEnd])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
							picker.$emit('pick', [start, end])
							setTimeout(() => {
								that.searchName()
							}, 200)
						}
					}
				]
			}
		}
	}
}
</script>
<style scoped lang="less">
.tab-content {
	height: 100%;
	display: flex;
	flex-direction: column;

	.content-header {
		padding: 10px 0;
		display: flex;
		justify-content: space-between;

		.btn-box {
			margin-left: auto;
		}
	}

	.w-table-layout {
		flex: 1;
	}
}
</style>
